export default __webpack_public_path__ + "static/media/animation.e060f532.gif";